import React, { Suspense, lazy } from 'react';
import { Route,Routes } from 'react-router-dom'
import Basepage from './components/Layout/Basepage';
import PageLoader from './components/Common/PageLoader';
import CreateEvent from './components/MainScreens/CreateEvents/CreateEvents.js';

const Login = lazy(() => import("./components/Pages/Login"));
const SignUp = lazy(() => import("./components/Pages/SignUp"));
const Recover = lazy(() => import("./components/Pages/Recover"));
const NotFound = lazy(() => import("./components/Pages/NotFound"));
// const Error500 = lazy(() => import("./components/Pages/Error500"));
// const Home = lazy(() => import("./components/Home/Home"));
const CompleteRegistration = lazy(() =>import("./components/Pages/CompleteRegistration"));
const ResetPassword = lazy(() => import("./components/Pages/ResetPassword"));
const About = lazy(() => import("./components/MainScreens/About/About"));
const Events = lazy(() => import("./components/MainScreens/Events/Events"));
const CreateNewEvent = lazy(() => import("./components/MainScreens/CreateEvents/CreateNewEvent"))
const EventsQuestions = lazy(() => import("./components/MainScreens/Events/EventsQuestions.js"));
const AddQuestions = lazy(() => import("./components/MainScreens/CreateEvents/AddQuestions"));
const ViewQuestion = lazy(() => import("./components/MainScreens/Events/ViewQuestion"));
const EventLeaderBoard = lazy(() => import("./components/MainScreens/LeaderBoard/EventLeaderBoard"));
const EditLeaderBoard = lazy(() => import("./components/MainScreens/LeaderBoard/EditLeaderBoard.js"));
const Users = lazy(() => import("./components/MainScreens/Users/Users.js"));
const Profile = lazy(() => import("./components/MainScreens/Profile/Profile.js"));
const EditUser = lazy(() => import("./components/MainScreens/Profile/EditUser.js"));

export default function AppRoutes() {
  return (
    <Basepage>
        <Suspense fallback={<PageLoader/>}>
            <Routes>
                <Route exact path="/signup" element={<SignUp />} />
                <Route exact path="/CreateEvents" element={<CreateEvent />} />
                <Route exact path="/CreateNewEvent" element={<CreateNewEvent />} />
                <Route exact path="/AddQuestions" element={<AddQuestions />}/>
                <Route exact path="/EventLeaderBoard" element={<EventLeaderBoard />}/>
                <Route exact path="/Evaluate" element={<EditLeaderBoard />}/>
                <Route exact path="/Users" element={<Users />}/>
                <Route exact path="/Profile" element={<Profile />}/>
                <Route exact path="/EditUser" element={<EditUser />}/>
                <Route index path="/" element={<Login />} />
                <Route path="/recover" element={<Recover />} />
                <Route path="/ActivateUserAccount/:code" element={<CompleteRegistration />}/>
                <Route path="/resetpassword/:code" element={<ResetPassword />} />
                <Route path="/notfound" element={<NotFound />} />
                <Route path="/About" element={<About />} />
                <Route path="/events" element={<Events />} />
                <Route path="/ViewQuestion" element={<ViewQuestion />} />
                <Route path="/eventQuest" element={<EventsQuestions />} />
            </Routes>
        </Suspense>
    </Basepage>
  )
}
